import graphql from './graphql';

const fetch = async params => {
  const status = await graphql('User_updateEmployee', 'status', 'mutation', {
    ...params,
  }).catch(err => err);

  return status;
};
export default fetch;
